import React, { useEffect, useState } from 'react';
import M from 'materialize-css'
import { axios } from '../../config'

const Glosario = () => {

	const [data, setData] = useState({palabra:'', definicion:''});
	const [glosarios, setGlosarios] = useState([])
	const [glosario, setGlosario] = useState({palabra:'', definicion:''})

	useEffect(()=>{
		M.Modal.init(document.querySelectorAll('.modal'), {});
		axios.get('/api/glosario')
		.then(r=>{
			setGlosarios(r.data)
		})
		.catch(r=>alert(r))
	},[])

	const _pushStore = (e) => {
		e.preventDefault()
		axios.post('/api/glosario', data)
		.then(r=>{
			setGlosarios([...glosarios, r.data])
			setData({palabra:'', definicion:''})
			M.toast({html:'cargada al glosario!'})
		})
		.catch(r=>alert(r))
	}

	const _pushEdit = (e) => {
		e.preventDefault()
		axios.put('/api/glosario', glosario)
		.then(r=>{
			M.toast({html:'glosario actualizado!'})
			setGlosarios(glosarios.map(f=>f.id===r.data.id?r.data:f))
		})
		.catch(r=>alert(r))
	}

	const _pushDelete = (obj) => {
		if(window.confirm(`esta seguro que desea eliminar: ${obj.palabra}`))
		axios.delete(`/api/glosario/${obj.id}`)
		.then(r=>{
			M.toast({html:'eliminada del glosario!'})
			setGlosarios(glosarios.filter(f=>f.id!==obj.id))
		})
		.catch(r=>alert(r))
	}

	const _showEdit = (obj) => {
		const instance = M.Modal.getInstance(document.querySelector('#modal-edit'));
		setGlosario(obj)
		instance.open();

		setTimeout(()=>{
			M.updateTextFields()
			M.textareaAutoResize(document.querySelector('#definicion2'));
		},1000)

	}

	return (
		<>
		<div id='modal1' className='modal'>
			<div className='modal-content'>
				<h4>Glosario</h4>
				<form onSubmit={_pushStore}>
					<div className='row'>
						<div className='input-field col s12'>
							<input value={data.palabra} onChange={(e)=>setData({...data, palabra:e.target.value})}id='palabra' type='text' className='validate' required/>
							<label htmlFor='palabra'>Palabra</label>
						</div>
						<div className='input-field col s12'>
							<textarea value={data.definicion} onChange={(e)=>setData({...data, definicion:e.target.value})} id='definicion' className='materialize-textarea' />
							<label htmlFor='definicion'>Definicion</label>
						</div>
					</div>
					<button className='modal-close btn waves-effect waves-light'>Agregar al glosario</button>
				</form>
			</div>
		</div>
		<div id='modal-edit' className='modal'>
			<div className='modal-content'>
				<h4>Editar del glosario</h4>
				<form onSubmit={_pushEdit}>
					<div className='row'>
						<div className='input-field col s12'>
							<input value={glosario.palabra} onChange={(e)=>setGlosario({...glosario, palabra:e.target.value})} id='palabra2' type='text' className='validate' required/>
							<label htmlFor='palabra2'>Palabra</label>
						</div>
						<div className='input-field col s12'>
							<textarea value={glosario.definicion} onChange={(e)=>setGlosario({...glosario, definicion:e.target.value})} id='definicion2' className='materialize-textarea' />
							<label htmlFor='definicion2'>Definicion</label>
						</div>
					</div>
					<button className='modal-close btn waves-effect waves-light'>Guardar</button>
				</form>
			</div>
		</div>
		<div className='card-panel'>
			<h4>Glosario</h4>
			<a className='waves-effect waves-light btn modal-trigger right' href='#modal1'>Agregar</a>
			<table>
				<thead>
					<tr>
						<th style={{width:'5%'}}>#</th>
						<th style={{width:'24%'}}>Palabra</th>
						<th>Definición</th>
						<th style={{width:'10%'}}>Opciones</th>
					</tr>
				</thead>
				<tbody>
				{glosarios.map((f,i)=>
					<tr key={i}>
						<td style={{width:'5%'}}>{i+1}</td>
						<td style={{width:'24%'}}>{f.palabra}</td>
						<td style={{whiteSpace:'normal'}}><p>{f.definicion}</p></td>
						<td style={{width:'10%'}}>
							<a onClick={()=>_showEdit(f)} className='waves-effect waves-light btn modal-trigger' href='#!'>Editar</a>
							<a onClick={()=>_pushDelete(f)} className='waves-effect waves-light btn' href='#!'>Eliminar</a>
						</td>
					</tr>
				)}
				</tbody>
			</table>

		</div>
		</>
	)
}

export default Glosario
